module.exports = __webpack_public_path__ + "static/media/assess-bkg-02.32a6872a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/assess-bkg-02.png
// module id = 285
// module chunks = 0